import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';

// Create an instance of axios with default settings
const axiosInstance = axios.create({
  baseURL: process.env.API_BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
});

// GET request
export const getRequest = async (url: string, config?: AxiosRequestConfig) => {
  try {
    const response: AxiosResponse = await axiosInstance.get(url, config);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// POST request
export const postRequest = async (
  url: string,
  data: any,
  config?: AxiosRequestConfig
) => {
  try {
    const response: AxiosResponse = await axiosInstance.post(url, data, config);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// PUT request
export const putRequest = async (
  url: string,
  data: any,
  config?: AxiosRequestConfig
) => {
  try {
    const response: AxiosResponse = await axiosInstance.put(url, data, config);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// DELETE request
export const deleteRequest = async (
  url: string,
  config?: AxiosRequestConfig
) => {
  try {
    const response: AxiosResponse = await axiosInstance.delete(url, config);
    return response.data;
  } catch (error) {
    handleError(error);
  }
};

// Error handling function
const handleError = (error: any) => {
  if (error.response) {
    console.error('Server responded with an error:', error.response.data);
  } else if (error.request) {
    console.error('Request was made but no response received:', error.request);
  } else {
    console.error('Error in setting up request:', error.message);
  }
  throw error;
};
